import { Chat } from "@/types";

import { axios } from "../axios.instance";

export type CreatePrivateChatRequest = {
  recipientId: string;
};

export type CreatePrivateChatResponse = Chat;

export const createPrivateChat = async (body: CreatePrivateChatRequest): Promise<CreatePrivateChatResponse> => {
  const { data } = await axios.post(`/chats/private/start`, body);

  return data;
};
